import { getIcons } from "@/utilities/getIcons"
import React, { SVGProps } from "react"

export type IconName = keyof typeof getIcons

interface IconsProps extends SVGProps<SVGSVGElement> {
	size?: number | string
}

export const Icons = (Object.keys(getIcons) as IconName[]).reduce(
	(acc, key) => {
		acc[key] = ({ size = "1em", ...props }: IconsProps) => (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={size}
				height={size}
				viewBox="0 0 24 24"
				fill="currentColor"
				{...props}
				dangerouslySetInnerHTML={{
					__html: getIcons[key].replace(/<svg[^>]*>|<\/svg>/g, ""),
				}}
			/>
		)
		return acc
	},
	{} as Record<IconName, React.FC<IconsProps>>,
)

interface IconProps extends SVGProps<SVGSVGElement> {
	name: IconName | string
	size?: number | string
}

export const Icon = ({ name, ...props }: IconProps) => {
	const IconComponent = Icons[name]

	if (!IconComponent) {
		console.warn(`Icon "${name}" no existe en el catálogo, loco.`)
		return null
	}

	return <IconComponent {...props} />
}

export default Icons
